import request from '../utils/request';
import { ApiResponse } from '../types';

export interface SystemSettings {
  site_name: string;
  logo_url: string;
  ai_icon_url: string;
  phone_number: string;
}

export interface QuickLink {
  id: number;
  title: string;
  description: string;
  image_url: string;
  icon_svg: string | null;
  link_url: string;
  sort_order: number;
  is_visible: number;
}

/** 获取公共系统设置 */
export const getPublicSettings = async (): Promise<ApiResponse<SystemSettings>> => {
  return request.get('/public/system-settings');
};

/** 获取公共快捷链接 */
export const getPublicQuickLinks = async (): Promise<ApiResponse<QuickLink[]>> => {
  return request.get('/public/quick-links');
};
